import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class BackupTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Backup Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Backup Kopie speichern', descriptionColumn: 'Speichert Ihre Einstellungen in einer config_backup.bin Datei, nachdem Sie Ihre Kamera konfiguriert haben. Klicken Sie einfach in die Backup Speichern Checkbox und Bestätigen Sie.' },
        { actionColumn: 'Backup Kopie laden', descriptionColumn: 'Um Ihre Einstellungen wiederherzustellen, z.B. nach einem Reset, klicken Sie in die Backup Laden checkbox, browsen Sie zur Backup Datei und Bestätigen Sie.' },
        { actionColumn: 'Durchsuchen', descriptionColumn: 'Klicken Sie hier, um nach Ihrer config_backup.bin Backup-Datei zu suchen. Bestätigen Sie die Datei um die Einstellungen wiederherzustellen.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

BackupTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(BackupTable)